import React from 'react';
import { Grid, Box } from '@mui/material';

import bg from '../../../assets/fattyPattyHeader.png';
import CateringForm from './CateringForm';
import fattyGrid1 from '../../../assets/fattyGrid1.jpg';
import fattyGrid2 from '../../../assets/fattyGrid2.png';
import fattyGrid3 from '../../../assets/fattyGrid3.png';
import fattyGrid4 from '../../../assets/fattyGrid4.png';
import fattyGrid5 from '../../../assets/fattyGrid5.jpg';
import fattyGrid6 from '../../../assets/fattyGrid16.png';

const Catering = () => {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        fontFamily: '"Jost", sans-serif',
      }}
    >
      <Grid
        container
        direction="column"
        sx={{
          display: 'grid',
          gridTemplateRows: 'auto 1fr',
          gap: { xs: 4, sm: 8, md: 12, lg: 20 },
          pb: { xs: 4, sm: 10 },
        }}
      >
        {/* Background Image */}
        <Grid
          item
          xs={12}
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: 200, sm: 300, lg: 300 },
          }}
        >
          <img
            src={bg}
            alt="Catering Background"
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        </Grid>

        {/* White Overlay Container */}
        <CateringForm />
      </Grid>
      {/* Desktop / tablet grid (hidden on xs) */}
      <Box
        sx={{
          display: { xs: 'none', sm: 'grid' },
          gridTemplateColumns: 'repeat(7, 1fr)',
          gridTemplateRows: 'repeat(4, 1fr)',
          gridColumnGap: 0,
          gridRowGap: 0,

          width: '100%',

          maxHeight: '700px',
        }}
      >
        <Box
          sx={{
            gridArea: '1 / 1 / 6 / 4',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid6}
            alt="Catering Main"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: `linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),
                linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),
                linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),
                linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),
                linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0,0.2))`,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-start',
              px: { xs: 2, sm: 4, md: 6, lg: 8 },
              pb: { xs: 2, sm: 4, md: 6, lg: 8 },
            }}
          >
            <Box
              component="span"
              sx={{
                color: '#fff',
                fontWeight: 900,
                // Responsive font sizes
                fontSize: { xs: '22px', sm: '48px', md: '64px', lg: '77px' },
                fontFamily: 'Jost, sans-serif',

                lineHeight: { xs: '1.2', sm: '1.2', md: '1.28', lg: '1.06' },
                letterSpacing: 0,
                textShadow: '0 2px 8px rgba(0,0,0,0.25)',
              }}
            >
              OUR
              <br />
              CATERING
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            gridArea: '1 / 4 / 3 / 6',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid5}
            alt="Catering 2"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
        <Box
          sx={{
            gridArea: '3 / 4 / 5 / 6',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid3}
            alt="Catering 3"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
        <Box
          sx={{
            gridArea: '1 / 6 / 3 / 8',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid2}
            alt="Catering 4"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
        <Box
          sx={{
            gridArea: '3 / 6 / 5 / 7',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid4}
            alt="Catering 5"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
        <Box
          sx={{
            gridArea: '3 / 7 / 5 / 8',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img
            src={fattyGrid1}
            alt="Catering 6"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      </Box>
      {/* Mobile-friendly structured grid (visible only on xs) */}
      <Box
        sx={{
          display: { xs: 'grid', sm: 'none' },
          gridTemplateColumns: 'repeat(2, 1fr)',
          gridAutoRows: 'auto',
          gap: 1,
          width: '100%',
          px: 1,
          mb: 2,
        }}
      >
        {/* Hero full-width with overlay */}
        <Box
          sx={{
            gridColumn: '1 / -1',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 1,
            aspectRatio: '16/9',
          }}
        >
          <img
            src={fattyGrid6}
            alt="Catering Main"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: `linear-gradient(0deg, rgba(0,0,0,0.22), rgba(0,0,0,0.22)),
                linear-gradient(0deg, rgba(0,0,0,0.12), rgba(0,0,0,0.12))`,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-start',
              px: { xs: 2 },
              pb: { xs: 2 },
            }}
          >
            <Box
              component="span"
              sx={{
                color: '#fff',
                fontWeight: 900,
                fontSize: { xs: '20px' },
                fontFamily: 'Jost, sans-serif',
                lineHeight: 1.1,
                letterSpacing: 0,
                textShadow: '0 2px 8px rgba(0,0,0,0.25)',
              }}
            >
              OUR
              <br />
              CATERING
            </Box>
          </Box>
        </Box>

        {/* Row: two images side-by-side */}
        <Box sx={{ overflow: 'hidden', borderRadius: 1, aspectRatio: '4/3' }}>
          <img
            src={fattyGrid5}
            alt="Catering 2"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>
        <Box sx={{ overflow: 'hidden', borderRadius: 1, aspectRatio: '4/3' }}>
          <img
            src={fattyGrid2}
            alt="Catering 4"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>

        {/* Row: two images side-by-side */}
        <Box sx={{ overflow: 'hidden', borderRadius: 1, aspectRatio: '4/3' }}>
          <img
            src={fattyGrid3}
            alt="Catering 3"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>
        <Box sx={{ overflow: 'hidden', borderRadius: 1, aspectRatio: '4/3' }}>
          <img
            src={fattyGrid4}
            alt="Catering 5"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>

        {/* Final full-width image */}
        <Box
          sx={{
            gridColumn: '1 / -1',
            overflow: 'hidden',
            borderRadius: 1,
            aspectRatio: '3/1',
          }}
        >
          <img
            src={fattyGrid1}
            alt="Catering 6"
            loading="lazy"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Catering;
